export default {
  state: {
    debtorDebts: [],
    debt: {
      debtor: {
        work_places: {},
        addresses: {},
      },
      payments: {},
      payment_amount: 0,
      payment_length: 0,
    },
  },
  mutations: {
    SET_DEBT(state, payload) {
      let amount = 0;
      state.debt = payload.debt;
      state.debt.debtor = payload.debt.debtor;
      state.debt.debtor.work_places = payload.debt.debtor.work_places;
      state.debt.debtor.addresses = payload.debt.debtor.addresses;
      state.debt.payments = payload.debt.payments;
      state.debt.contragent = payload.debt.contragent;

      payload.debt.payments.forEach((payment) => {
        amount += parseInt(payment.amount, 10);
      });
      state.debt.payment_amount = amount;
      state.debt.payment_length = state.debt.payments.length;
    },
    SET_DEBTOR_DEBTS(state, payload) {
      state.debtorDebts = payload.debts;
    },
  },
  actions: {
    async GET_DEBT_INFO({ commit }, payload) {
      try {
        const { data } = await window.axios.get(`/debts/${payload}`);
        commit('SET_DEBT', data);
      } catch (err) {
        throw err;
      }
    },
    async GET_DEBTOR_DEBTS({ commit }, payload) {
      try {
        const { data } = await window.axios.get(`/debtor/${payload}/debts`);
        commit('SET_DEBTOR_DEBTS', data);
      } catch (err) {
        throw err;
      }
    },
  },
  getters: {
    debt(state) {
      return state.debt;
    },
    debtorDebts(state) {
      return state.debtorDebts;
    },
  },
};
